import PropTypes from 'prop-types';
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import TextField from 'ContentComponents/cmv2/fields/Text';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class PlainTextField extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      htmlError: false,
      hublError: false
    };
    this.handleFieldChange = value => {
      const strippedHtmlValue = value && typeof value === 'string' ? value.replace(/<(?:.|\n)*?>/gm, '') : value;
      const strippedHublValue = value && typeof value === 'string' ? value.replace(/{{(.)*}}/gm, '') : value;
      const isHtmlError = strippedHtmlValue !== value;
      const isHublError = strippedHublValue !== value;
      this.setState({
        htmlError: isHtmlError,
        hublError: isHublError
      });
      if (!isHtmlError && !isHublError) {
        this.props.onFieldChange(value);
      }
    };
  }
  renderErrorMessage(htmlError, hublError) {
    let errorMessageKey;
    if (htmlError) {
      errorMessageKey = 'errorHtmlNotSupported';
    } else if (hublError) {
      errorMessageKey = 'errorHublNotSupported';
    }
    return errorMessageKey && /*#__PURE__*/_jsx(Small, {
      use: "error",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `knowledgeContentUI.templateEditor.${errorMessageKey}`
      })
    });
  }
  render() {
    const {
      htmlError,
      hublError
    } = this.state;
    const hasError = htmlError || hublError;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(TextField, {
        error: hasError,
        onFieldChange: this.handleFieldChange,
        readOnly: this.props.readOnly,
        value: this.props.value
      }), hasError && this.renderErrorMessage(htmlError, hublError)]
    });
  }
}
PlainTextField.propTypes = {
  onFieldChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  value: PropTypes.string.isRequired
};
export default PlainTextField;